import React, { Component } from "react";
import { Modal, Button } from 'react-bootstrap'
import { strings } from "../../../constants/strings";
import { ModalBadges } from '../../../components/Badges'

export default class DashboardModal extends Component {
  render() {
    //let devicesImg = '/react/images/dashboard/' + strings.Web_Dashboard_Devices_img    
    let devicesImg = '/react/images/qr/one_link_qr.png'
    let premiumImg = '/react/images/dashboard/premium_pop-up/' + strings.Web_Dashboard_Premium_img
  
  if(this.props.isPremiumModal) {
      return (
        <Modal
          show={this.props.modalIsVisible}
          onHide={this.props.hideModal}
          dialogClassName='modal-dialog-centered modal-custom-size premium-pop-up'
          contentClassName='dashboard-modal'
        >
          <Modal.Header className='pb-0' closeButton>
          </Modal.Header>
          <div className="modal-header pt-0">
            <h2 
            className="modal-title dashboard-modal-title" 
            dangerouslySetInnerHTML={{__html: this.props.titleTxt}}
            >
            </h2>
          </div>
          <Modal.Body>
          <img className="popup-main-slide" src={premiumImg} alt="" />
            <div className='flex-center'>
            <ul className='premium-ul'>
              <li>{this.props.contentTxt[0]}</li>
              <li>{this.props.contentTxt[1]}</li>
              <li>{this.props.contentTxt[2]}</li>
            </ul>
            </div>
            <a 
            href={strings.Web_prices_link} className={"ex-button yellow " + this.props.amazonBtnClass} style={ //Amazon button class contain not related to Amazon tag needed for Analytics
              {
                fontSize: '20px',
                fontWeight: '35px'
              }
            }
            >{this.props.buttonTxt}</a>
            
          </Modal.Body>
        </Modal>
      );
    } else {
      return (
        <Modal
          show={this.props.modalIsVisible}
          onHide={this.props.hideModal}
          dialogClassName='modal-dialog-centered modal-custom-size qr-popup'
          contentClassName='dashboard-modal'
        >
          <Modal.Header className='pb-0' closeButton>
          </Modal.Header>
          <div className="modal-header pt-0">
            <h2 className="modal-title" style={{
              fontSize: this.props.titleTxt.length <= 80 ? '2.4rem' : '2rem'
            }}
            dangerouslySetInnerHTML={{__html: this.props.titleTxt}}
            >
            </h2>
          </div>
          <Modal.Body>
            <img className="popup-main-slide" src={devicesImg} alt="" />    
            <div className="badges-container">        
            <ModalBadges
              amazonBtnClass = {this.props.amazonBtnClass}
              googleBtnClass = {this.props.googleBtnClass}
              appleBtnClass = {this.props.appleBtnClass}
            />
            </div>
          </Modal.Body>
          
        </Modal>
      )
    }    
  }
}
